import ApiService, { ApiArguments } from '@/api/api_service';
import {
  ZoomPhoneRecordingApi,
  ZoomPhoneRecordingApiDownloadZoomPhoneRecordingRequest,
} from '@/api/openapi';

export class ZoomPhoneRecordingApiService extends ApiService {
  api = new ZoomPhoneRecordingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async downloadZoomPhoneRecording({
    request,
    options,
    errorHandlers,
  }: ApiArguments<ZoomPhoneRecordingApiDownloadZoomPhoneRecordingRequest>) {
    return this.checkResponse<void>(
      this.api.downloadZoomPhoneRecording(request, options),
      errorHandlers,
    );
  }
}
